export default "__VITE_ASSET__CyE6gOpk__"